export enum ArchiveMaterialInfo {
  MATERIAL_TYPE = 'MATERIAL_TYPE',
  MATERIAL_MODEL = 'MATERIAL_MODEL',
  MATERIAL_YEAR = 'MATERIAL_YEAR',
  MATERIAL_BATCH = 'MATERIAL_BATCH',
}
